<template lang="pug">
.ber-rating-info 
  .ber-rating-label BER
  .ber-rating-value(
    v-if="rating.value !== 0"
    :class="[rating.code.toLowerCase()]"
    :style="{backgroundColor: getRatingColor(rating.code) || '#FFFFFF', color: pickTextOn(getRatingColor(rating.code))}") {{ rating.code }}
  .ber-rating-not-aplicable(v-else) N/A
</template>

<script lang="ts">
import { Rating } from "@/types";
import { PropType, defineComponent } from "vue";
import { getRatingColor } from "@/helpers";
import {pickTextOn} from "@/helpers";

export default defineComponent({
  props: {
    rating: {
      type: Object as PropType<Rating>,
      required: true,
    },
  },
  setup() {
    return { getRatingColor };
  },
  methods: {pickTextOn},
});
</script>

<style scoped lang="scss">
@import "@/assets/styles/components/ber-rating.scss";

.ber-rating-info {
  display: flex;
  width: 100%;

  &>div {
    flex: 1;
    text-align: center;
    padding: 0.5rem;
    font-weight: 700;
  }

  .ber-rating-label {
    background: #363636;
    color: white;
    position: relative;
    $tringle-size: 0.5rem;

    &:after {
      content: "";
      position: absolute;
      right: -$tringle-size;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 0;
      height: 0;
      border-top: $tringle-size solid transparent;
      border-bottom: $tringle-size solid transparent;
      border-left: $tringle-size solid rgb(46, 46, 46);
    }
  }

  .ber-rating-not-aplicable {
    background-color: #ababab;
    color: white;
  }
}
</style>
